import microService from "../utils/microServices";

export const syncUserPorfile = async ({ payload }) => {
  let params;
  if (payload.cartId) {
    params = {
      guestCartId: payload.cartId,
    };
  }
  const profileInfoRequest = await microService.post(
    "api",
    "profileSync",
    {},
    params
  );
  let profileInfo = profileInfoRequest.response?.data?.result;
  if (
    !profileInfoRequest.fail &&
    profileInfo &&
    profileInfo?.result &&
    profileInfo?.result?.magentoProfileResponse &&
    profileInfo?.result?.magentoProfileResponse[0]
  ) {
    return { ...profileInfo, pageAction: payload.pageAction };
  } else if (profileInfoRequest.error?.status == 401) {
    throw {
      apiFailStatus: "401",
    };
  } else {
    throw new Error();
  }
};
